import { useEffect } from "react";
import { getStrapConfigKey } from "../utils/cartStorage";

export default function useSessionPersistence({
    currentHideIndex,
    shortPos,
    longPos,
    cutOption,
    activePart,
    preSelectedSize,
    strapSelections,
    config,
    hasSessionPosRef,
}) {
    useEffect(() => {
        sessionStorage.setItem("savedHideIndex", currentHideIndex);
    }, [currentHideIndex]);

    useEffect(() => {
        if ((hasSessionPosRef && hasSessionPosRef.current) || shortPos.x !== 0 || shortPos.y !== 0) {
            sessionStorage.setItem("savedShortPos", JSON.stringify(shortPos));
        }
    }, [shortPos, hasSessionPosRef]);

    useEffect(() => {
        if ((hasSessionPosRef && hasSessionPosRef.current) || longPos.x !== 0 || longPos.y !== 0) {
            sessionStorage.setItem("savedLongPos", JSON.stringify(longPos));
        }
    }, [longPos, hasSessionPosRef]);

    useEffect(() => {
        sessionStorage.setItem("savedCutOption", cutOption);
    }, [cutOption]);

    useEffect(() => {
        sessionStorage.setItem("savedActivePart", activePart);
    }, [activePart]);

    useEffect(() => {
        if (Object.keys(strapSelections).length === 0) return;
        try {
            localStorage.setItem(getStrapConfigKey(), JSON.stringify({
                ts: Date.now(),
                selections: strapSelections,
                config,
            }));
        } catch (e) { }
    }, [strapSelections, config]);

    useEffect(() => {
        if (preSelectedSize) {
            sessionStorage.setItem("savedPreSelectedSize", JSON.stringify(preSelectedSize));
        } else {
            sessionStorage.removeItem("savedPreSelectedSize");
        }
    }, [preSelectedSize]);
}
